export const CAN_APPROVE_ACCESS_PERMISSION = 'CAN_APPROVE_ACCESS_PERMISSION';
export const GET_TICKET_DETAIL = 'GET_TICKET_DETAIL';
export const GET_WORKFLOW_STEPS_ID = 'GET_WORKFLOW_STEPS_ID';
export const GET_ACCESS_PERMISSION_MOTIVES = 'GET_ACCESS_PERMISSION_MOTIVES';
export const CAN_EMIT_COMMENTS_OVER_ACCESS_PERMISSION_APPROVAL =
    'CAN_EMIT_COMMENTS_OVER_ACCESS_PERMISSION_APPROVAL';
export const GET_TAPE_DELIVERIES = 'GET_TAPE_DELIVERIES';
export const GET_TAPE_DELIVERIES_OPTIONS = 'GET_TAPE_DELIVERIES_OPTIONS';
export const GET_TAPE_DELIVERY = 'GET_TAPE_DELIVERY';
export const GET_TAPE_CHANGE_TICKET = 'GET_TAPE_CHANGE_TICKET';
